/* global window, document */
(function () {
  'use strict';

  function initMinigrid(section) {
    if (!section || section.__p817Init) return;
    section.__p817Init = true;

    var toolbar = section.querySelector('.p817-minigrid__toolbar');
    if (!toolbar) return;

    function setCols(scope, cols){
      if(scope === 'sm'){
        section.style.setProperty('--p817-cols-mobile', cols);
        section.style.setProperty('--p817-cols-sm', cols);
      } else {
        section.style.setProperty('--p817-cols', cols);
        section.style.setProperty('--p817-cols-md', cols);
      }
    }

    function updatePressed(group, target){
      if(!group) return;
      group.querySelectorAll('.p817-density__btn').forEach(function(btn){
        btn.setAttribute('aria-pressed', String(btn === target));
      });
    }

    toolbar.querySelectorAll('.p817-density__btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var scope = btn.getAttribute('data-scope'); // "sm" or "lg"
        var cols  = parseInt(btn.getAttribute('data-cols'), 10) || 2;
        updatePressed(btn.closest('.p817-density__group'), btn);
        setCols(scope, cols);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.p817-minigrid').forEach(initMinigrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target && evt.target.querySelector('.p817-minigrid');
    if (section) initMinigrid(section);
  });
})();
